module.exports = require("./dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// jquery (bower component)
// module id = 149
// module chunks = 1